// @flow
import React from 'react'
import PRStatusBadge from './PRStatusBadge'

type Props = {
  prNumber: string,
  prTitle: string,
  prStatus: string,
  href: string,
  header?: boolean
}

const PRTitle = (props: Props): React$Element<'div'> => <div style={{
  display: 'flex',
  alignItems: 'center',
  fontSize: props.header ? '26px' : '18px',
  fontWeight: 'bold',
  color: '#24384e'
}}>
  <a href={props.href} target='_blank'>
    <span style={{
      color: 'gray',
      marginRight: '5px'
    }}>
      #{props.prNumber}
    </span>
    <span style={{
      color: 'black',
      textOverflow: 'ellipsis'
    }}>
      {props.prTitle}
    </span>
  </a>
  <PRStatusBadge status={props.prStatus} marginLeft={'10px'} />
</div>

export default PRTitle



// WEBPACK FOOTER //
// ./app/javascript/packs/components/pull_request/PRTitle.js